$(document).ready(function () {
    var notreadmodal = $('#notreadmodal');
    $(notreadmodal).find('table tr td a').click(function () {
        $(this).parents('tr').find('.haveread-btn').removeAttr('disabled');
    });
});
